import { GroupsContextProvider } from '@context/GroupsContext';
import { useRouter } from 'next/router';
import GroupsWrapper from './GroupsWrapper';

const GroupsContainer = ({ groupUID }) => {
  const {
    query: { goalUID }
  } = useRouter();

  return (
    <GroupsContextProvider goalUID={goalUID} groupUID={groupUID}>
      <GroupsWrapper />
    </GroupsContextProvider>
  );
};

export default GroupsContainer;
